module.exports = __webpack_public_path__ + "assets/servileasing_web.03890ffc2ab0ed83dbfa2632058c8afd.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/servileasing_web.png
 ** module id = 931
 ** module chunks = 0
 **/